<mat-dialog-content class="rounded-0">
    <div class="d-flex justify-content-between">
        <h5 class="fw-semibold">Stellcode: {{data.stellcode}}</h5>
        <img class="ms-3 avs-modal-close-btn mb-1" width="30" src="assets/icons/x.svg"
             alt="close-modal-icon" (click)="onCloseModalClicked()">
    </div>
    <div class="d-flex justify-content-around p-4">
        <div class="p-3">
            <div class="d-flex justify-content-center">
              <img [src]="environment.apiAddress + data.path">
            </div>
        </div>
    </div>
    <div class="d-flex justify-content-between mt-3 gap-3">
        <button class="btn btn-sm btn-outline-danger rounded-0" (click)="onCloseModalClicked()">Abbrechen</button>
        <button class="btn btn-sm btn-secondary rounded-0" (click)="onDeleteImageClicked()">Bild entfernen</button>
    </div>
</mat-dialog-content>
